import { PERMISSIONS } from '../../constants';
import ClientBillEdit from './ClientBillEdit';

export { ClientBillEdit };

export default {
  edit: ClientBillEdit,
  name: 'client-bills',
  permissions: [PERMISSIONS.ADMIN],
};
